import { render, staticRenderFns } from "./o-light.vue?vue&type=template&id=72a512a6&"
import script from "./o-light.js?vue&type=script&lang=js&"
export * from "./o-light.js?vue&type=script&lang=js&"
import style0 from "./o-light.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports